export default __webpack_public_path__ + "static/media/TropomiNL.cda3648b.svg";